import { BaseAdapter } from "@modules/+new/payments/shared-payments/entities/base-adapter";
import { AssetPrice as OldAssetPrice } from "@models/tradable/split/asset_price";
import { IndexAllocation, IndexAllocationAdapter } from "@modules/+new/assets/domain/entities/index-allocation.model";
import { PriceChanges } from "@modules/+new/assets/domain/entities/price-changes.model";

export interface AssetPrice {
	readonly id: number; // TODO unused?
	readonly circulatingSupply: number;
	indexAssets: IndexAllocation[];
	readonly avgPrice: number;
	priceAmountChanges: PriceChanges;
	pricePercentageChanges: PriceChanges;
}

export class AssetPriceAdapter extends BaseAdapter<OldAssetPrice, AssetPrice> {
	private indexAllocationAdapter = new IndexAllocationAdapter();
	public constructor() {
		super();
	}
	public adapt(item: OldAssetPrice): AssetPrice {
		if (!item) {
			return null;
		}

		return {
			id: Number(item.getId()),
			circulatingSupply: item.getCirculatingSupply() ?? 0,
			indexAssets: this.indexAllocationAdapter.adaptMany(item.getIndexAllocations()),
			avgPrice: item.getPrice() ?? 0,
			priceAmountChanges: {
				day: item.getChange24hAmount() ?? 0,
				week: item.getChange1wAmount() ?? 0,
				month: item.getChange1mAmount() ?? 0,
				year: item.getChange1yAmount() ?? 0
			},
			pricePercentageChanges: {
				day: item.getChange24h() ?? 0,
				week: item.getChange1w() ?? 0,
				month: item.getChange1m() ?? 0,
				year: item.getChange1y() ?? 0
			}
		};
	}
}
